(() => {
  const KEY = 'lm_farr_logo_sequence_v1';
  const TARGET = '/pages/fast-ass-redneck-racing';
  const WINDOW_MS = 6500;

  document.addEventListener('click', (event) => {
    const logo = event.target.closest('.site-header__logo-image, .site-header__logo-link');
    if (!logo || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    let sequence = { count: 0, startedAt: 0 };
    try {
      sequence = JSON.parse(sessionStorage.getItem(KEY)) || sequence;
    } catch (_) {}

    const now = Date.now();
    if (!sequence.startedAt || now - sequence.startedAt > WINDOW_MS) {
      sequence = { count: 0, startedAt: now };
    }
    sequence.count += 1;

    try { sessionStorage.setItem(KEY, JSON.stringify(sequence)); } catch (_) {}

    if (sequence.count >= 5) {
      event.preventDefault();
      try { sessionStorage.removeItem(KEY); } catch (_) {}
      window.location.assign(TARGET);
    }
  }, true);
})();
